import { Nullable } from 'models/helpers'

/** Consent document types recorded by the backend consent endpoints (ISSUE-2012). */
export enum ConsentType {
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
}

/** Integration channels a consent can be recorded for. */
export type ConsentChannel = 'PROPSTACK'

/** Current consent status for a single document type on an integration channel. */
export interface ConsentStatusDTO {
  /** The consent document type. */
  consentType: ConsentType
  /** The latest version the user has accepted, or null if never accepted. */
  acceptedVersion: Nullable<string>
  /** The version currently required by the backend. */
  requiredVersion: string
  /** True when the accepted version matches the required version. */
  upToDate: boolean
}
